module.exports = __webpack_public_path__ + "img/百香果10.486f10de.png";